<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.prodCode">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="默认库位" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.laType">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="库位类型" class="EL-Form-Item">
                        <el-select v-model="pagination.searchType">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="合格默认库位" value="10"></el-option>
                            <el-option label="备料默认库位" value="20"></el-option>
                            <el-option label="退料默认库位" value="30"></el-option>
                            <el-option label="调拨移库地面库位" value="40"></el-option>
                            <el-option label="QC外协库位" value="50"></el-option>
                            <el-option label="间材默认入库库位" value="60"></el-option>
                            <el-option label="叫料默认库位" value="70"></el-option>
                            <el-option label="供应商物料类型" value="80"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getSysMaterialDeploy()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="物料配置">
                <el-button :loading="!!loading" v-authority="'BACK_MENU5_M2_B1'" class="btn-t-edit" @click="(add_or_edit = true), (editBoxShow = true)">新增</el-button>
                <el-button v-authority="'BACK_MENU5_M2_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table v-loading="loading" :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getSysMaterialDeploy" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="tableTotal">
                <el-table-column prop="fcCode" label="所属工厂" />
                <el-table-column prop="prodCode" label="物料编号" />
                <el-table-column prop="prodDesc" label="物料描述" />
                <el-table-column prop="laType" label="默认库位" />
                <el-table-column prop="searchType" label="类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.searchType == 10">合格默认库位</span>
                        <span v-if="scope.row.searchType == 20">备料默认库位</span>
                        <span v-if="scope.row.searchType == 30">退料默认库位</span>
                        <span v-if="scope.row.searchType == 40">调拨移库地面库位</span>
                        <span v-if="scope.row.searchType == 50">QC外协库位</span>
                        <span v-if="scope.row.searchType == 60">间材默认入库库位</span>
                        <span v-if="scope.row.searchType == 70">叫料默认库位</span>
                        <span v-if="scope.row.searchType == 80">供应商物料类型</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" />
                <el-table-column prop="updateTime" label="修改时间" />
               <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU5_M2_B2'" :disabled="scope.row.mtXa ? true : false" size="mini" type="primary" @click="
                (add_or_edit = false),
                  (editBoxShow = true),
                  (mainObj = JSON.parse(JSON.stringify(scope.row)))
              " plain icon="el-icon-edit-outline" />
                        <el-button v-authority="'BACK_MENU5_M2_B3'" type="danger" @click="deleteRow(scope.row.mdId)" size="mini" plain icon="el-icon-delete" />
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 新增&&编辑框 -->
        <el-dialog :title="add_or_edit ? '新增' : '编辑'" :close-on-click-modal="false" :visible.sync="editBoxShow" :model="mainObj" @open="open" :style="$popups.popups(0.5,0.6)" class="fromDialog">
            <span class="formClass">
                <el-form :inline="true" label-position="top" label-width="80px" :model="mainObj" :rules="rules" ref="mainObj">
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="物料编号" prop="prodCode" class="EL-Form-Item">
                            <el-input v-model.trim="mainObj.prodCode" maxlength="20"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="物料描述" prop="prodDesc" class="EL-Form-Item">
                            <el-input v-model.trim="mainObj.prodDesc" maxlength="50"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="库位" prop="laType" class="EL-Form-Item">
                            <el-input v-model="mainObj.laType" maxlength="5"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="类型" prop="searchType" class="EL-Form-Item">
                            <el-select v-model="mainObj.searchType" placeholder="请选择">
                                <el-option label="合格默认库位" value="10"></el-option>
                                <el-option label="备料默认库位" value="20"></el-option>
                                <el-option label="退料默认库位" value="30"></el-option>
                                <el-option label="调拨移库地面库位" value="40"></el-option>
                                <el-option label="QC外协库位" value="50"></el-option>
                                <el-option label="间材默认入库库位" value="60"></el-option>
                                <el-option label="叫料默认库位" value="70"></el-option>
                                <el-option label="供应商物料类型" value="80"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button size="small" type="info" @click="editBoxShow = false">
                    取 消
                </el-button>
                <el-button size="small" type="primary" v-if="add_or_edit" @click="add">
                    新 增
                </el-button>
                <el-button size="small" type="primary" v-else @click="editRow">
                    修 改
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "StockCheckTaskDetail",
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                form: {},
                rules: {
                    mtCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    mtName: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    mtCheck: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    mtType: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    validityMonth: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                },

                mtTypeList: [], //物料类型集合

                showRoleBox: true,
                add_or_edit: Boolean, //新增|编辑
                editBoxShow: false, //编辑框
                dialogFormVisible: false,
                formLabelWidth: "140px", // 对话框大小
                tableHeight: 0, //表格高度
                testValue: 1,
                mainObj: {},
                pagination: {
                    pageSize: 50,
                    pageNum: 1,
                    prodCode: "",
                    laType: "",
                    searchType: "",
                    prodDesc:""
                },
				tableTotal:0,
                mainData: [],
                fcode: localStorage.getItem("fcCode") || "",

                downloadLoading: false, //下载中

                loading: 0,

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getSysMaterialDeploy(newVal);
                    }, 1000)
                },
                deep: true,
            },
        },
        methods: {
            //获取数据
            getSysMaterialDeploy() {
                // this.loading++
                this.$http
                    .request({
                        url: "/api/sysMaterialDeploy/getSysMaterialDeploy",
                        method: "GET",
                        params: this.pagination,
                    })
                    .then((resp) => {
                        // this.loading--
                        if (resp.status == 100) {
                            // console.log(resp.data.list.length);
                            this.mainData = resp.data.list || [];
                            this.tableTotal = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        // this.loading--;
                    });
            },

            //表单验证
            submitForm(formName) {
                let r = Boolean;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        r = true;
                    } else {
                        r = false;
                    }
                });
                return r;
            },
            //框打开
            open() {
                if (this.add_or_edit) {
                    //新增
                    this.mainObj = JSON.parse(JSON.stringify({}));
                } else {
                    this.getSysMaterialDeploy();
                }
            },
            //新增
            add() {
                if (this.fcode != "") {
                    this.mainObj.fcCode = this.fcode;
                }
                if (this.submitForm("mainObj")) {
                    this.$http
                        .request({
                            url: "/api/sysMaterialDeploy/insertSysMaterialDeploy",
                            method: "POST",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "新增成功！",
                                    type: "success",
                                });
                                this.logRemarks = "material：物料新增成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "material：物料新增失败";
                            }
                            this.logContent =
                                "prodCode" +
                                this.mainObj.prodCode +
                                "\t prodDesc" +
                                this.mainObj.prodDesc;
                            this.systemLog();
                            this.editBoxShow = false;
                            this.getSysMaterialDeploy();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //编辑
            editRow() {
                if (this.submitForm("mainObj")) {
                    this.$http
                        .request({
                            url: "/api/sysMaterialDeploy/updateSysMaterialDeploy",
                            method: "POST",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "修改成功！",
                                    type: "success",
                                });
                                this.logRemarks = "material：物料编辑成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "material：物料编辑失败";
                            }
                            this.logContent =
                                "prodCode" +
                                this.mainObj.prodCode +
                                "\t prodDesc" +
                                this.mainObj.prodDesc;
                            this.systemLog();
                            this.editBoxShow = false;
                            this.getSysMaterialDeploy();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //删除
            deleteRow(mtId) {
                this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                        confirmButtonText: "删除",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/sysMaterialDeploy/deleteSysMaterialDeploy",
                                method: "DELETE",
                                showLoading: true,
                                params: {
                                    mtId: mtId,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$notify({
                                        title: "成功",
                                        message: "删除成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "material：物料删除成功";
                                } else {
                                    this.$notify.error({
                                        title: "失败",
                                        message: "删除失败",
                                    });
                                    this.logRemarks = "material：物料删除失败";
                                }
                                this.logContent = "mdId：" + mtId;
                                this.systemLog();
                                this.getSysMaterialDeploy();
                            })
                            .catch((error) => {
                                this.$notify.error({
                                    title: "失败",
                                    message: "调用失败",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            },

            //重置
            resetData() {
                this.pagination={
                    pageSize: 50,
                    pageNum: 1,
                    prodCode: "",
                    laType: "",
                    searchType: "",
                    prodDesc:""
                },
				this.tableTotal=0;
                // this.getSysMaterialDeploy();
            },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    prodCode: this.pagination.prodCode,
                    laType: this.pagination.laType,
                    searchType: this.pagination.searchType,
                    prodDesc:this.pagination.prodDesc,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/sysMaterialDeploy/getSysMaterialDeploy',
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.mtCheck == '10') {
                            c['mtCheck'] = '合格默认库位'
                        } else if (c.mtCheck == '20') {
                            c['mtCheck'] = '备料默认库位'
                        } else if (c.mtCheck == '30') {
                            c['mtCheck'] = '退料默认库位'
                        }else if (c.mtCheck == '40') {
                            c['mtCheck'] = '调拨移库地面库位'
                        } else if (c.mtCheck == '50') {
                            c['mtCheck'] = 'QC外协库位'
                        }else if (c.mtCheck == '60') {
                            c['mtCheck'] = '间材默认入库库位'
                        } else if (c.mtCheck == '70') {
                            c['mtCheck'] = '叫料默认库位'
                        }else if (c.mtCheck == '80') {
                            c['mtCheck'] = '供应商物料类型'
                        }

                    })
                    const tHeader = ['所属工厂','物料编号', '物料描述', '默认库位', '类型', '创建时间', '修改时间']
                     const filterVal = ['fcCode', 'prodCode', 'prodDesc', 'laType', 'searchType', 'createTime','updateTime']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '物料配置数据'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "sys_material_deploy：导出物料配置数据"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },


            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "物料主数据",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated() {
            this.getmtTypeList()
            /* 获取首页的数据 */
            this.getSysMaterialDeploy();
        },
    };
</script>

<style scoped>
</style>